import { WidgetKeys } from 'jamespot-user-api';
import { Widget } from 'jamespot-front-business';
import { commonComponentsRegistry } from '../../registry/CommonRegistry';
import { useAppSelector } from '../../redux/store';

const JRCLoader = commonComponentsRegistry.getLazyComponent('Loader');

/*
    Widget state
*/

//TODO: REFACTORING
export const WidgetState = ({ uniqid, inplace }: { name: WidgetKeys; uniqid: string; inplace: boolean }) => {
    const state = useAppSelector((state) => Widget.selectors.selectWidgetState(state, uniqid));

    if (state?.loading) {
        return (
            <div
                style={{
                    position: 'absolute',
                    inset: 0,
                    backgroundColor: 'rgba(255,255,255,.7)',
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                <JRCLoader />
            </div>
        );
    }

    if (state?.hover) {
        return (
            <div
                style={{
                    position: 'absolute',
                    inset: 0,
                    backgroundColor: 'rgba(255,255,255,.7)',
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                }}></div>
        );
    }

    if (!state?.initialized && inplace) {
        return <></>;
    }

    return <></>;
};
